import { ARE_ALERTS_DISABLED } from '@/graphql/querys/areAlertsDisabledData';
import { useSuspenseQuery } from '@apollo/client';

export const useAreAlertsDisabled = (deviceId: string) => {
  const { data } = useSuspenseQuery(ARE_ALERTS_DISABLED, {
    variables: { deviceId },
  });

  return data.device.alerts.activeConfigurations.length === 0;
};
